import { createDefaultLoadable, ILoadableWrapper, ISite, Loadable } from "../../models"
import { createDefaultILoadableArray, ILoadableArray } from "../../models/loadable"

export interface ITelegramMetadata {
  id: string
  chat_id: string
}

export interface IWhatsappMetadata {
  id: string
  phone_number: string
}

export interface IRecipientBase {
    id: string
    name: string
    site_ids: string[]
    sites: ISite[]
    camera_sites: ISite[]
}

export type IRecipient = 
  { type: "telegram", data: ITelegramMetadata} & IRecipientBase |
  { type: "whatsapp", data: IWhatsappMetadata} & IRecipientBase 


export interface RecipientState extends Loadable {
  recipients: ILoadableArray<ILoadableWrapper<IRecipient>>,
  notification: Loadable
}

export const initialNotificationState: RecipientState = {
  ...createDefaultLoadable(),
  recipients: createDefaultILoadableArray(),
  notification: {
    ...createDefaultLoadable()
  }
};


